import React from "react";
import "./Legal.css";

const DonneesPersonnelles = () => {
  return (
    <section className="legal-page">
      <div className="legal-content">
        <h1>Données personnelles</h1>
        <hr />

        <h2>Mentions relatives à l'utilisation de données personnelles</h2>

        <p>
          JCP Industries s'engage à ce que les traitements de vos données personnelles,
          effectués sur le site, soient conformes au règlement général sur la protection
          des données (RGPD) et à la loi Informatique et Libertés.
        </p>

        <h3>Formulaire de contact</h3>
        <p>
          JCP Industries collecte vos données personnelles lorsque vous remplissez le
          formulaire de contact.<br />
          Votre nom, prénom et adresse mail sont collectés.<br />
          Ce traitement de données a pour finalité de permettre la prise en compte de votre demande.<br />
          En utilisant ce formulaire, vous consentez à ce que ces données soient traitées par JCP Industries.<br />
          JCP Industries ne communique pas ces données à un tiers et ne les transfère pas en dehors de l'Union Européenne.<br />
          Ces données sont conservées jusqu'à la fin du traitement de votre demande.
        </p>

        <h3>Formulaire de recrutement</h3>
        <p>
          JCP Industries collecte vos données personnelles lorsque vous remplissez le
          formulaire de recrutement.<br />
          Votre nom, prénom, adresse mail et CV sont collectés.<br />
          Ce traitement de données a pour finalité de permettre la prise en compte de votre candidature.<br />
          En utilisant ce formulaire, vous consentez à ce que ces données soient traitées par JCP Industries.<br />
          JCP Industries ne communique pas ces données à un tiers et ne les transfère pas en dehors de l'Union Européenne.<br />
          Ces données sont conservées jusqu'à la fin du traitement de votre demande.
        </p>

        <h3>Droit des personnes</h3>
        <p>
          Le Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016
          sur la protection des données vous confère un droit d'information, d'accès, de
          rectification, de suppression, de réclamation auprès de l'autorité de contrôle
          (CNIL) ou de limitation du traitement de vos données personnelles.
        </p>

        <h3>Point de contact</h3>
        <p>
          Pour toute information ou exercice de vos droits sur les données personnelles
          gérées par JCP Industries, vous pouvez contacter notre délégué à la protection
          des données (DPO) :
        </p>
        <ul>
          <li>
            Par mail à l'adresse mail :{" "}
            <a href="mailto:jcp-contact@orange.fr">jcp-contact@orange.fr</a>
          </li>
          <li>
            Par courrier, à l'adresse suivante :<br />
            DPO – JCP Industries<br />
            5 Allée Roland Garros - ZI Les Renouillères<br />
            93360 Neuilly-Plaisance
          </li>
        </ul>

        <hr />

        <h2>Mentions relatives à l'utilisation de cookies</h2>

        <h3>Qu'est-ce qu'un cookie ?</h3>
        <p>
          Un cookie est un fichier déposé sur votre ordinateur lors de la visite d'un site
          ou de la consultation d'une publicité. Les cookies ont pour but de collecter des
          informations relatives à votre navigation sur les sites et de vous adresser des
          services personnalisés.
        </p>
        <p>
          Pour en savoir plus vous pouvez consulter le site de la CNIL :<br />
          <a href="https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser" target="_blank" rel="noreferrer">
            https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser
          </a><br />
          <a href="https://www.cnil.fr/fr/site-web-cookies-et-autres-traceurs" target="_blank" rel="noreferrer">
            https://www.cnil.fr/fr/site-web-cookies-et-autres-traceurs
          </a>
        </p>

        <h3>Comment gérer mes cookies ?</h3>
        <p>
          Certains cookies sont soumis au consentement.<br />
          Le popup Panneau de gestion des cookies vous donne le contrôle sur les cookies utilisés.<br />
          L'accord ainsi donné est valable pour une durée maximum de treize (13) mois à compter
          du premier dépôt dans l'équipement du terminal.<br />
          Vous pouvez à tout moment retirer votre consentement et changer le paramétrage des
          cookies dans ce popup.<br />
          Le refus de consentement n'entrainera pas de dégradation des services proposés.
        </p>
        <p>
          Si vous ne l'avez pas fait depuis le bandeau d'information lors de votre arrivée sur
          notre site, vous pouvez à tout moment accepter ou refuser les cookies via notre
          gestionnaire de cookies.
        </p>

        <h3>Comment le Site utilise les cookies ?</h3>
        <p>Nous utilisons les cookies aux fins suivantes :</p>

        <p>
          <strong>Cookies obligatoires</strong><br />
          Ils sont indispensables afin de garantir le bon fonctionnement du site et de ses fonctionnalités.
        </p>

        <p>
          <strong>Stockage local (cookies persistants)</strong><br />
          Ce type de cookie a pour finalité de fluidifier et d'améliorer votre navigation sur
          le site. Il mémorise des informations d'affichage qu'il ne plus nécessaires de charger
          lors de vos prochaines visites.
        </p>

        <p>
          <strong>Cookies de session</strong><br />
          Ils permettent de mémoriser la langue de navigation.
        </p>

        <p>
          <strong>Cookies de réseaux sociaux</strong><br />
          Les cookies qui sont déposés via les boutons réseaux sociaux ont pour finalité de
          permettre aux utilisateurs du site de faciliter le partage de contenu et d'améliorer
          la convivialité.<br />
          Cela peut également permettre aux réseaux sociaux de suivre votre activité dans le
          cas ou votre compte de réseau social sera connecté simultanément lors de votre visite.
        </p>

        <p>
          <strong>Cookies de mesures d'audience</strong><br />
          Le site utilise Google Analytics pour recueillir les statistiques sur le trafic,
          afin que nous puissions faire les ajustements nécessaires pour répondre au mieux
          aux besoins des utilisateurs. Nous recueillons par exemple des données sur le nombre
          de visiteurs, la durée moyenne des visites, ou encore le nombre de pages vues.
        </p>

      </div>
    </section>
  );
};

export default DonneesPersonnelles;
